/** @jsxImportSource @emotion/react */
import { Spin } from '@ssmm/ui';
import { Container, Divider, Section } from 'components/landing/ui';
import React from 'react';

import S5Desktop from './desktop';
import S5Mobile from './mobile';

const S5 = React.forwardRef(({ width, ...rest }, ref) => (
  <Container ref={ref}>
    <Section
      css={{
        paddingTop: 50,
        '@media (min-width:992px)': { paddingTop: 100 },
        '@media (min-width:1366px)': { paddingTop: 120 },
      }}
    >
      <Spin spinning={!rest.reviews} css={{ width: '100%', minHeight: 300 }}>
        {rest.reviews && <>{width >= 992 ? <S5Desktop {...rest} /> : <S5Mobile {...rest} />}</>}
      </Spin>

      <Divider
        css={{
          marginTop: 50,
          '@media (min-width:1366px)': { marginTop: 70 },
        }}
      />
    </Section>
  </Container>
));

export default S5;
